import Image from 'next/future/image';
import Link from 'next/link';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

const FootPrintBlogs = (props: any) => {
  const { blogs, title } = props;
  const [isAllLoaded, setIsAllLoaded] = useState(false);
  const loadMoreSize: number = 4;
  const initSize: number = 4;
  // Initial display blogs
  const [displayNumber, setDisplayNumber] = useState(initSize);

  useEffect(() => {
    if (blogs?.length < 4) {
      setDisplayNumber(blogs?.length);
      setIsAllLoaded(true);
    } else {
      setDisplayNumber(4);
      setIsAllLoaded(false);
    }
  }, [blogs]);

  function handleShowMore() {
    setDisplayNumber((prevPostNum: number) => prevPostNum + loadMoreSize);
    if (displayNumber + loadMoreSize >= blogs?.length) setIsAllLoaded(true);
    else setIsAllLoaded(false);
  }

  function handleShowLess() {
    setDisplayNumber(initSize);
    setIsAllLoaded(false);
  }

  return (
    <>
      <section className="footprint-section">
        <div className="container">
          <h2 className="section-heading">{title}</h2>

          <div className="row justify-content-center g-3">
            {blogs &&
              blogs?.slice(0, displayNumber).map((item: any) => {
                return (
                  <>
                    <div
                      key={item?.attributes?.Slug}
                      className="col-lg-6 col-md-6 col-sm-12"
                    >
                      <div className="card steps-card">
                        <Image
                          sizes="(max-width: 375px) 295px, (max-width: 576px) 260px, (max-width: 768px) 355px, (max-width: 992px) 470px, (max-width: 1280px) 560px"
                          className="img-fluid card-img card-img-top"
                          src={
                            item?.attributes?.Thumbnail?.data?.attributes?.url
                              ? item?.attributes?.Thumbnail?.data?.attributes
                                  ?.url
                              : item?.attributes?.Thumbnail?.data?.attributes
                                  ?.alternativeText
                          }
                          width="330"
                          height="145"
                          alt={
                            item?.attributes?.Thumbnail?.data?.attributes
                              ?.alternativeText
                              ? item?.attributes?.Thumbnail?.data?.attributes
                                  ?.alternativeText
                              : 'alt'
                          }
                        />
                        <div className="card-body pb-0">
                          <h5 className="card-title">
                            {item?.attributes?.Title}{' '}
                            {item?.attributes?.Featured}
                          </h5>
                          <p className="card-text mb-2">
                            {item?.attributes?.Excerpt}
                          </p>
                        </div>
                        <div className="card-footer bg-white border-0">
                          <Link
                            href="/blog/[slug]"
                            as={`/blog/${item?.attributes?.Slug}`}
                          >
                            <a className="link">
                              <FormattedMessage id="blogs-read-more" />
                            </a>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </>
                );
              })}
          </div>

          <div className="row mt-4">
            <div className="col-lg-12 text-center">
              {!isAllLoaded && (
                <button
                  type="button"
                  onClick={handleShowMore}
                  className="btn btn-primary btn-lg"
                >
                  <FormattedMessage id="blogs-load-more" />
                </button>
              )}
              {isAllLoaded && blogs?.length > initSize && (
                <button
                  type="button"
                  onClick={handleShowLess}
                  className="btn btn-outline-primary btn-lg"
                >
                  <FormattedMessage id="show-less" />
                </button>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FootPrintBlogs;
